var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_c('router-view',{attrs:{"name":"nav"}}),_c('div',{staticClass:"grow mx-10 mb-10"},[_c('InfluencerHeader'),_c('router-view',{staticClass:"mt-4"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }